import { render, staticRenderFns } from "./scratch.vue?vue&type=template&id=655810c6&scoped=true"
import script from "./scratch.vue?vue&type=script&lang=js"
export * from "./scratch.vue?vue&type=script&lang=js"
import style0 from "./scratch.vue?vue&type=style&index=0&id=655810c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655810c6",
  null
  
)

export default component.exports